module.exports = __webpack_public_path__ + "img/Frage5_1024x768.74f31d59.jpg";